<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title" *ngIf="dataLoaded && showSummaryView">
      <div class="ui-helper-clearfix">
        <h1>Dashboard Summary {{ strDays }}</h1>
        <div class="radio" style="text-align: center">
          <label>
            <input
              type="radio"
              name="Days"
              value="0"
              (click)="setdays(0)"
              [(ngModel)]="radioSelected"
            /><b>90 Days&nbsp;</b>
          </label>
          <label>
            <input
              type="radio"
              name="Days"
              value="1"
              (click)="setdays(1)"
              [(ngModel)]="radioSelected"
            /><b>30 Days&nbsp;</b>
          </label>
          <label>
            <input
              type="radio"
              name="Days"
              value="2"
              (click)="setdays(2)"
              [(ngModel)]="radioSelected"
            /><b>7 Days</b>
          </label>
        </div>
        <button
          type="button"
          pButton
          label="Export To CSV"
          (click)="dt.exportCSV()"
          style="float: Right; font-weight: bold"
        ></button>
      </div>

      <p-table
        #dt
        exportFilename="Supplier_Dashboard_Summary"
        [value]="summaryDataList"
        sortMode="single"
        reorderableColumns="true"
        scrollable="true"
        selectionMode="single"
        scrollHeight="49vh"
        [(selection)]="selectedItems"
        columnResizeMode="expand"
        styleClass="inbox-data-table dataTable ui-datatable ui-widget"
        [responsive]="true"
      >
        <ng-template>
          pTemplate="header">
          <tr>
            <th
              [style]="{
                width: '180px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              rowspan="2"
            >
              Supplier
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              rowspan="2"
            >
              Jobs
            </th>
            <th
              [style]="{
                width: '100px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              colspan="2"
            >
              Area
            </th>
            <th
              [style]="{
                width: '150px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              colspan="2"
            >
              Earnings
            </th>
            <th
              [style]="{
                width: '100px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              colspan="2"
            >
              Delivery Stats
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              rowspan="2"
            >
              Driver Rating
            </th>
            <th
              [style]="{
                width: '110px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              colspan="2"
            >
              ABBA Tasks
            </th>
            <th
              [style]="{
                width: '195px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
              colspan="3"
            >
              Distance
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#cc0055'
              }"
              rowspan="2"
            >
              Rej Jobs
            </th>
          </tr>
          <tr>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              In
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#cc0055'
              }"
            >
              Out
            </th>
            <th
              [style]="{
                width: '75px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              £
            </th>
            <th
              [style]="{
                width: '75px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              Avg
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              On Time
            </th>
            <th
              [style]="{
                width: '50px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#cc0055'
              }"
            >
              Delay
            </th>
            <th
              [style]="{
                width: '55px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              Single
            </th>
            <th
              [style]="{
                width: '55px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#022369'
              }"
            >
              Multi
            </th>
            <th
              [style]="{
                width: '65px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#0083c9'
              }"
            >
              Min
            </th>
            <th
              [style]="{
                width: '65px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#0083c9'
              }"
            >
              Max
            </th>
            <th
              [style]="{
                width: '65px',
                'font-size': 'small',
                'font-weight': 'bold',
                color: '#0083c9'
              }"
            >
              Avg
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="rowClick(item)">
            <td>{{ item.supplier }}</td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.jobCountArray != undefined"
                pTooltip="90 Days : {{ item.jobCountArray[0] }}&#13;30 Days : {{
                  item.jobCountArray[1]
                }}&#13;7 Days : {{ item.jobCountArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.jobCount
                }}</span>
              </div>
              <div *ngIf="item.jobCountArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.areaHomeArray != undefined"
                pTooltip="90 Days : {{ item.areaHomeArray[0] }}&#13;30 Days : {{
                  item.areaHomeArray[1]
                }}&#13;7 Days : {{ item.areaHomeArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.areaHome
                }}</span>
              </div>
              <div *ngIf="item.areaHomeArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.areaOutsideArray != undefined"
                pTooltip="90 Days : {{ item.areaOutsideArray[0] }}&#13;30 Days : {{
                  item.areaOutsideArray[1]
                }}&#13;7 Days : {{ item.areaOutsideArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #cc0055">{{
                  item.areaOutside
                }}</span>
              </div>
              <div *ngIf="item.areaOutsideArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.earningsArray != undefined"
                pTooltip="90 Days : {{ item.earningsArray[0] }}&#13;30 Days : {{
                  item.earningsArray[1]
                }}&#13;7 Days : {{ item.earningsArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.earnings
                }}</span>
              </div>
              <div *ngIf="item.earningsArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.earningsArray != undefined"
                pTooltip="90 Days : {{ item.averageArray[0] }}&#13;30 Days : {{
                  item.averageArray[1]
                }}&#13;7 Days : {{ item.averageArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.average
                }}</span>
              </div>
              <div *ngIf="item.earningsArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.statOntimeArray != undefined"
                pTooltip="90 Days : {{ item.statOntimeArray[0] }}&#13;30 Days : {{
                  item.statOntimeArray[1]
                }}&#13;7 Days : {{ item.statOntimeArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.statOntime
                }}</span>
              </div>
              <div *ngIf="item.statOntimeArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.statDelayArray != undefined"
                pTooltip="90 Days : {{ item.statDelayArray[0] }}&#13;30 Days : {{
                  item.statDelayArray[1]
                }}&#13;7 Days : {{ item.statDelayArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #cc0055">{{
                  item.statDelay
                }}</span>
              </div>
              <div *ngIf="item.statDelayArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.rateArray != undefined"
                pTooltip="90 Days : {{ item.rateArray[0] }}&#13;30 Days : {{
                  item.rateArray[1]
                }}&#13;7 Days : {{ item.rateArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.rate
                }}</span>
              </div>
              <div *ngIf="item.rateArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.SingleArray != undefined"
                pTooltip="90 Days : {{ item.SingleArray[0] }}&#13;30 Days : {{
                  item.SingleArray[1]
                }}&#13;7 Days : {{ item.SingleArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.Single
                }}</span>
              </div>
              <div *ngIf="item.SingleArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.MultipleArray != undefined"
                pTooltip="90 Days : {{ item.MultipleArray[0] }}&#13;30 Days : {{
                  item.MultipleArray[1]
                }}&#13;7 Days : {{ item.MultipleArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #022369">{{
                  item.Multiple
                }}</span>
              </div>
              <div *ngIf="item.MultipleArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.distanceMinArray != undefined"
                pTooltip="90 Days : {{ item.distanceMinArray[0] }}&#13;30 Days : {{
                  item.distanceMinArray[1]
                }}&#13;7 Days : {{ item.distanceMinArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #0083c9">{{
                  item.distanceMin
                }}</span>
              </div>
              <div *ngIf="item.distanceMinArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.distanceMaxArray != undefined"
                pTooltip="90 Days : {{ item.distanceMaxArray[0] }}&#13;30 Days : {{
                  item.distanceMaxArray[1]
                }}&#13;7 Days : {{ item.distanceMaxArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #0083c9">{{
                  item.distanceMax
                }}</span>
              </div>
              <div *ngIf="item.distanceMaxArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.distanceAvgArray != undefined"
                pTooltip="90 Days : {{ item.distanceAvgArray[0] }}&#13;30 Days : {{
                  item.distanceAvgArray[1]
                }}&#13;7 Days : {{ item.distanceAvgArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #0083c9">{{
                  item.distanceAvg
                }}</span>
              </div>
              <div *ngIf="item.distanceAvgArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
            <td>
              <div
                style="text-align: right"
                *ngIf="item.refusedJobCountArray != undefined"
                pTooltip="90 Days : {{ item.refusedJobCountArray[0] }}&#13;30 Days : {{
                  item.refusedJobCountArray[1]
                }}&#13;7 Days : {{ item.refusedJobCountArray[2] }}"
                tooltipPosition="bottom"
              >
                <span style="font-size: smaller; font-weight: bold; color: #cc0055">{{
                  item.refusedJobCount
                }}</span>
              </div>
              <div *ngIf="item.refusedJobCountArray == undefined">
                <img src="assets/images/loader.gif" style="max-width: 70px; max-height: 20px" />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DEPRECATED --

      <p-dataTabl #dt exportFilename="Supplier_Dashboard_Summary" [value]="summaryDataList" sortMode="single" reorderableColumns="true"
             scrollable="true" selectionMode="single" scrollHeight="49vh"
             [(selection)]="selectedItems" columnResizeMode="expand"
             (onRowDblclick)="rowClick($event)"
             styleClass="inbox-data-table dataTable ui-datatable ui-widget" [responsive]="true">
        <p-header>
          <div class="ui-helper-clearfix">
            <h1>Dashboard Summary {{strDays}}</h1>
            <div class="radio" style="text-align:center">
              <label>
                <input type="radio" name="Days" value="0" (click)="setdays(0)" [(ngModel)]="radioSelected"><b>90 Days&nbsp;</b>
              </label>
              <label>
                <input type="radio" name="Days" value="1" (click)="setdays(1)" [(ngModel)]="radioSelected"><b>30 Days&nbsp;</b>
              </label>
              <label>
                <input type="radio" name="Days" value="2" (click)="setdays(2)" [(ngModel)]="radioSelected"><b>7 Days</b>
              </label>
            </div>
            <button type="button" pButton label="Export To CSV" (click)="dt.exportCSV()" style="float:Right; font-weight:bold"></button>
          </div>
        </p-header>
        <p-headerColumnGroup>
          <p-row>
            <p-column [style]="{'width':'180px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Supplier" field="supplier" rowspan="2" [sortable]="true"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Jobs" field="jobCount" rowspan="2" [sortable]="true"></p-column>
            <p-column [style]="{'width':'100px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Area" colspan="2"></p-column>
            <p-column [style]="{'width':'150px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Earnings" colspan="2"></p-column>
            <p-column [style]="{'width':'100px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Delivery Stats" colspan="2"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Driver Rating" rowspan="2" field="rate" [sortable]="true"></p-column>
            <p-column [style]="{'width':'110px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="ABBA Tasks" colspan="2"></p-column>
            <p-column [style]="{'width':'195px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Distance" colspan="3"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#cc0055'}" header="Rej Jobs" rowspan="2" field="refusedJobCount" [sortable]="true"></p-column>
          </p-row>
          <p-row>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="In" field="areaHome" [sortable]="true"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#cc0055'}" header="Out" field="areaOutside" [sortable]="true"></p-column>
            <p-column [style]="{'width':'75px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="£" field="earnings" [sortable]="true"></p-column>
            <p-column [style]="{'width':'75px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Avg" field="average" [sortable]="true"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="On Time" field="statOntime" [sortable]="true"></p-column>
            <p-column [style]="{'width':'50px', 'font-size':'small', 'font-weight':'bold', 'color': '#cc0055'}" header="Delay" field="statDelay" [sortable]="true"></p-column>
            <p-column [style]="{'width':'55px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Single" field="Single" [sortable]="true"></p-column>
            <p-column [style]="{'width':'55px', 'font-size':'small', 'font-weight':'bold', 'color': '#022369'}" header="Multi" field="Multiple" [sortable]="true"></p-column>
            <p-column [style]="{'width':'65px', 'font-size':'small', 'font-weight':'bold', 'color': '#0083c9'}" header="Min" field="distanceMin" [sortable]="true"></p-column>
            <p-column [style]="{'width':'65px', 'font-size':'small', 'font-weight':'bold', 'color': '#0083c9'}" header="Max" field="distanceMax" [sortable]="true"></p-column>
            <p-column [style]="{'width':'65px', 'font-size':'small', 'font-weight':'bold', 'color': '#0083c9'}" header="Avg" field="distanceAvg" [sortable]="true"></p-column>
          </p-row>
        </p-headerColumnGroup>
        <p-column [style]="{'width':'180px', 'color': '#022369'}" field="supplier"></p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="jobCount">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.jobCountArray != undefined" pTooltip="90 Days : {{item.jobCountArray[0]}}&#13;30 Days : {{item.jobCountArray[1]}}&#13;7 Days : {{item.jobCountArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.jobCount}}</span>
            </div>
            <div *ngIf="item.jobCountArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="areaHome">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.areaHomeArray != undefined" pTooltip="90 Days : {{item.areaHomeArray[0]}}&#13;30 Days : {{item.areaHomeArray[1]}}&#13;7 Days : {{item.areaHomeArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.areaHome}}</span>
            </div>
            <div *ngIf="item.areaHomeArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="areaOutside">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.areaOutsideArray != undefined" pTooltip="90 Days : {{item.areaOutsideArray[0]}}&#13;30 Days : {{item.areaOutsideArray[1]}}&#13;7 Days : {{item.areaOutsideArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #cc0055">{{item.areaOutside}}</span>
            </div>
            <div *ngIf="item.areaOutsideArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'75px'}" styleClass="text-ellipsis" field="earnings">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.earningsArray != undefined" pTooltip="90 Days : {{item.earningsArray[0]}}&#13;30 Days : {{item.earningsArray[1]}}&#13;7 Days : {{item.earningsArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.earnings}}</span>
            </div>
            <div *ngIf="item.earningsArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'75px'}" styleClass="text-ellipsis" field="average">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.earningsArray != undefined" pTooltip="90 Days : {{item.averageArray[0]}}&#13;30 Days : {{item.averageArray[1]}}&#13;7 Days : {{item.averageArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.average}}</span>
            </div>
            <div *ngIf="item.earningsArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="statOntime">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.statOntimeArray != undefined" pTooltip="90 Days : {{item.statOntimeArray[0]}}&#13;30 Days : {{item.statOntimeArray[1]}}&#13;7 Days : {{item.statOntimeArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.statOntime}}</span>
            </div>
            <div *ngIf="item.statOntimeArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="statDelay">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.statDelayArray != undefined" pTooltip="90 Days : {{item.statDelayArray[0]}}&#13;30 Days : {{item.statDelayArray[1]}}&#13;7 Days : {{item.statDelayArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #cc0055">{{item.statDelay}}</span>
            </div>
            <div *ngIf="item.statDelayArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="rate">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.rateArray != undefined" pTooltip="90 Days : {{item.rateArray[0]}}&#13;30 Days : {{item.rateArray[1]}}&#13;7 Days : {{item.rateArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.rate}}</span>
            </div>
            <div *ngIf="item.rateArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'55px'}" styleClass="text-ellipsis" field="Single">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.SingleArray != undefined" pTooltip="90 Days : {{item.SingleArray[0]}}&#13;30 Days : {{item.SingleArray[1]}}&#13;7 Days : {{item.SingleArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.Single}}</span>
            </div>
            <div *ngIf="item.SingleArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <
        <p-column [style]="{'width':'55px'}" styleClass="text-ellipsis" field="Multiple">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.MultipleArray != undefined" pTooltip="90 Days : {{item.MultipleArray[0]}}&#13;30 Days : {{item.MultipleArray[1]}}&#13;7 Days : {{item.MultipleArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #022369">{{item.Multiple}}</span>
            </div>
            <div *ngIf="item.MultipleArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'65px'}" styleClass="text-ellipsis" field="distanceMin">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.distanceMinArray != undefined" pTooltip="90 Days : {{item.distanceMinArray[0]}}&#13;30 Days : {{item.distanceMinArray[1]}}&#13;7 Days : {{item.distanceMinArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #0083c9">{{item.distanceMin}}</span>
            </div>
            <div *ngIf="item.distanceMinArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'65px'}" styleClass="text-ellipsis" field="distanceMax">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.distanceMaxArray != undefined" pTooltip="90 Days : {{item.distanceMaxArray[0]}}&#13;30 Days : {{item.distanceMaxArray[1]}}&#13;7 Days : {{item.distanceMaxArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #0083c9">{{item.distanceMax}}</span>
            </div>
            <div *ngIf="item.distanceMaxArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'65px'}" styleClass="text-ellipsis" field="distanceAvg">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.distanceAvgArray != undefined" pTooltip="90 Days : {{item.distanceAvgArray[0]}}&#13;30 Days : {{item.distanceAvgArray[1]}}&#13;7 Days : {{item.distanceAvgArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #0083c9">{{item.distanceAvg}}</span>
            </div>
            <div *ngIf="item.distanceAvgArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
        <p-column [style]="{'width':'50px'}" styleClass="text-ellipsis" field="refusedJobCount">
          <ng-template pTemplate="body" let-item="rowData">
            <div style="text-align:right" *ngIf="item.refusedJobCountArray != undefined" pTooltip="90 Days : {{item.refusedJobCountArray[0]}}&#13;30 Days : {{item.refusedJobCountArray[1]}}&#13;7 Days : {{item.refusedJobCountArray[2]}}" tooltipPosition="bottom">
              <span style="font-size:smaller;font-weight:bold;color: #cc0055">{{item.refusedJobCount}}</span>
            </div>
            <div *ngIf="item.refusedJobCountArray == undefined"><img src="assets/images/loader.gif" style='max-width:70px;max-height:20px'></div>
          </ng-template>
        </p-column>
      </p-dataTable>

      -->
    </div>
    <div *ngIf="showDetailView">
      <div class="ui-g">
        <div class="ui-g-8">
          <h1>Supplier: {{ supplierName }}</h1>
        </div>
        <div class="ui-g-4">
          <button
            class="pull-right"
            (click)="displaySummaryView()"
            pButton
            type="submit"
            label="<< Back"
          ></button>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Job Count</h2>
          <p-chart
            type="line"
            height="250px"
            [options]="JobCountOptions"
            [data]="JobCountData"
          ></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Area</h2>
          <p-chart type="line" height="250px" [options]="AreaOptions" [data]="AreaData"></p-chart>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Earnings</h2>
          <p-chart
            type="bar"
            height="250px"
            [options]="EarningsOptions"
            [data]="EarningsData"
          ></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Driver Rating</h2>
          <p-chart
            type="line"
            height="250px"
            [options]="RatingOptions"
            [data]="RatingData"
          ></p-chart>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Refused Jobs</h2>
          <p-chart
            type="line"
            height="250px"
            [options]="RefusedJobOptions"
            [data]="RefusedJob"
          ></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Distance Travelled</h2>
          <p-chart
            type="bar"
            height="250px"
            [options]="PerformanceOptions"
            [data]="PerformanceData"
          ></p-chart>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Data Management</h2>
          <p-chart
            type="bar"
            height="250px"
            [options]="DataOptions"
            [data]="ManagementData"
          ></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Distance</h2>
          <p-chart
            type="bar"
            height="250px"
            [options]="DistanceOptions"
            [data]="DistanceData"
          ></p-chart>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Delivery Stats</h2>
          <p-chart type="line" height="250px" [options]="StatOptions" [data]="StatData"></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Customer Delivery Stats</h2>
          <p-chart
            type="horizontalBar"
            height="250px"
            [options]="CustStatOptions"
            [data]="CustStatData"
          ></p-chart>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">ABBA Jobs</h2>
          <p-chart type="line" height="250px" [options]="ABBAOptions" [data]="ABBAData"></p-chart>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <h2 style="margin-top: 1.5em; margin-bottom: 0.5em">Customer ABBA Jobs</h2>
          <p-chart
            type="horizontalBar"
            height="250px"
            [options]="CustABBAOptions"
            [data]="CustABBAData"
          ></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
